import { el } from '@/ui/hud';

/** Chest glyphs shared by the stage, the sign-up sheet and the top bar's pill. */

/** The chest glyph (Blockari's Icons.chest). */
export function chestIcon(): SVGSVGElement {
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', '2');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  svg.setAttribute('aria-hidden', 'true');
  for (const d of ['M4 11h16v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z', 'M4 11V9a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2', 'M10 11v3h4v-3']) {
    const p = document.createElementNS(ns, 'path');
    p.setAttribute('d', d);
    svg.append(p);
  }
  return svg;
}

/** The pill's burst as a chest lands in it (Blockari's PillBurst): a flash, a ring, eight sparks. */
export function burst(pill: HTMLElement | null): void {
  if (!pill) return;
  pill.querySelector('.w21-chest-pill-burst')?.remove();
  const b = el('i', 'w21-chest-pill-burst');
  b.setAttribute('aria-hidden', 'true');
  for (let i = 0; i < 8; i++) {
    const s = el('b');
    s.style.setProperty('--a', `${i * 45 + 22}deg`);
    b.append(s);
  }
  pill.append(b);
  pill.classList.remove('popped');
  void pill.offsetWidth;
  pill.classList.add('popped');
  setTimeout(() => b.remove(), 700);
}


const SVG_NS = 'http://www.w3.org/2000/svg';

function glyph(paths: readonly string[], extra?: (svg: SVGSVGElement) => void): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', '2');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  svg.setAttribute('aria-hidden', 'true');
  for (const d of paths) {
    const p = document.createElementNS(SVG_NS, 'path');
    p.setAttribute('d', d);
    svg.append(p);
  }
  extra?.(svg);
  return svg;
}

/** A padlock: a guest's chests are locked until there is an account. */
export function lockIcon(): SVGSVGElement {
  return glyph(['M8 11V8a4 4 0 0 1 8 0v3'], (svg) => {
    const body = document.createElementNS(SVG_NS, 'rect');
    body.setAttribute('x', '5');
    body.setAttribute('y', '11');
    body.setAttribute('width', '14');
    body.setAttribute('height', '10');
    body.setAttribute('rx', '2');
    svg.append(body);
  });
}

/** The padlock come off (the celebration). */
export function unlockIcon(): SVGSVGElement {
  return glyph(['M8 11V8a4 4 0 0 1 7.5-2'], (svg) => {
    const body = document.createElementNS(SVG_NS, 'rect');
    body.setAttribute('x', '5');
    body.setAttribute('y', '11');
    body.setAttribute('width', '14');
    body.setAttribute('height', '10');
    body.setAttribute('rx', '2');
    svg.append(body);
  });
}
